<div class="mv5">
  <jb-related-content-block *ngIf="sectionBlockData">
    <!-- icon -->
    <jb-icon
      *ngIf="!!sectionBlockData.icon && sectionBlockData?.icon?.length"
      [name]="sectionBlockData.icon[0]?.src"
    ></jb-icon>
    <!-- logo -->
    <jb-image
      *ngIf="!!sectionBlockData.logo && sectionBlockData?.logo?.length"
      [src]="sectionBlockData.logo[0].src"
      [alt]="sectionBlockData.logo[0].alt"
      [height]="sectionBlockData.logo[0].height"
      [width]="sectionBlockData.logo[0].width"
      [cropped]="true"
      [defer]="true"
      [placeholder]="
        sectionBlockData.logo[0].src
          | dynamicImageWidthPipe: 'placeholder':placeholderParams
      "
      [isLazy]="enableLazyLoadImage"
    ></jb-image>
    <!-- header -->
    <ng-container *ngIf="!!sectionBlockData.title" JbTitle>
      {{ sectionBlockData.title }}
    </ng-container>
    <!-- description -->
    <jb-related-content-block-description
      *ngIf="!!sectionBlockData.description"
    >
      {{ sectionBlockData.description }}
    </jb-related-content-block-description>
    <!-- link -->
    <a
      *ngIf="!!sectionBlockData.link && sectionBlockData.link.length"
      [jbSitemapLinker]="sectionBlockData.link[0]?.href"
      [target]="sectionBlockData.link[0].newWindow"
      [dotLinkIcon]="sectionBlockData.link[0].newWindow"
      jbActionLink
      >{{ sectionBlockData.link[0].title }}</a
    >
  </jb-related-content-block>
</div>
